import Container from './root-composer.container';
import Component from './root-composer.component';

export { Container, Component };

export default Container;
